<template>
    <div>
        <h4 class="mb-3">Modifier le portefeuille <span class="badge bg-info">
                <i :class="'bi ' + actions[operation].icon"></i>
                {{ actions[operation].label }}
            </span></h4>
        <div class="row">
            <div class="mb-3 col-md-6">
                <label for="wallet_amount" class="form-label fw-bold">Montant*</label>
                <input type="text" class="form-control" id="wallet_amount" placeholder="Montant"
                    v-model="formData.amount" required>
                <small class="text-danger" v-if="errors['amount']">{{ errors['amount'][0] }}</small>
            </div>
            <div class="mb-3 col-md-6">
                <label for="wallet_description" class="form-label fw-bold">Description</label>
                <textarea type="text" class="form-control" id="wallet_description" placeholder="Description"
                    v-model="formData.description">
                </textarea>
                <small class="text-danger" v-if="errors['description']">{{ errors['description'][0] }}</small>
            </div>

        </div>
        <div class="row">
            <div class="d-flex justify-content-end">
                <button class="btn btn-primary" @click="save">Enregistrer</button>
            </div>
        </div>
    </div>
</template>

<script>
import formMixin from '@/mixins/formMixin';

export default {
    name: 'WalletEditForm',
    mixins: [formMixin],
    props: {
        operation: {
            type: [String],
            default: 'add'
        }
    },
    data() {
        return {
            url: '/wallets',
            actions: {
                add: {label: 'Crédit', icon: 'bi-arrow-up-short',key:'credit'},
                subtract: {label: 'Débit', icon: 'bi-arrow-down-short',key:'debit'},
                correct: {label: 'Correction', icon: 'bi-arrows-collapse',key:'correction'}
            }
        }
    },
    methods:{
        beforeSave() {
            this.formData.type = this.actions[this.operation].key;
        }
    }
}

</script>